import React from 'react';
import './BelongingCover.css';

export default function BelongingCover({ variant = 'page' }) {
  return (
    <div
      className={`belonging-cover belonging-cover--${variant}`}
      role="presentation"
      aria-hidden="true"
    />
  );
}
